import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1545009850674181';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
// Avoid loading the pixel inside the Magic Patterns preview iframe (which sandboxes
// third-party scripts and surfaces them as "Script error."). Only fire on the real domain.
const shouldLoadPixel = (): boolean => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  if (!host) return false;
  if (host === 'localhost' || host === '127.0.0.1') return false;
  if (host.includes('magicpatterns')) return false;
  return true;
};
export const MetaPixel = () => {
  useEffect(() => {
    if (!shouldLoadPixel()) return;
    try {
      if (window.fbq) {
        window.fbq('track', 'PageView');
        return;
      }
      // Official Meta Pixel base code, hardened with try/catch + crossOrigin
      ;
      (function (f: any, b, e, v, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.crossOrigin = 'anonymous';
        t.src = v;
        t.onerror = () => {
          /* swallow cross-origin load failures silently */
        };
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch {
      /* never let pixel failures break the page */
    }
  }, []);
  // Render the <noscript> fallback only on the real domain too.
  if (!shouldLoadPixel()) return null;
  return <noscript data-id="element-12">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-13" />
    </noscript>;
};